import { ModalOtrosProductosDto } from './../../../feature/monitoreo/data/ModalOtrosProductosDto';
import { GenericDto } from 'src/app/core/data/GenericDto';
import { Component, OnInit, ViewChild, OnDestroy, TemplateRef, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';

import { SubSink } from 'subsink';

import { BlockUI, NgBlockUI } from 'ng-block-ui';

import { SubjectsService } from '../../../core/services/subjects.service';
import { DetalleSucursalesService } from 'src/app/feature/monitoreo/services/detalle-sucursales.service';
import { SweetAlertService } from '../../../core/services/sweet-alert.service';

import { InformacionFiltroDetalleSucursalesDto } from 'src/app/feature/monitoreo/data/InformacionFiltroDetalleSucursalesDto';
import { TotalProductosCardDetalleSucursalesDto } from '../../../feature/monitoreo/data/TotalProductosCardDetalleSucursalesDto';
import { BlockTemplateComponent } from '../../../core/template/block-template/block-template.component';
import { constantes } from '../../../core/data/Constantes';

@Component({
  selector: 'app-card-monitoreo-detalle-sucursales',
  templateUrl: './card-monitoreo-detalle-sucursales.component.html',
  styleUrls: ['./card-monitoreo-detalle-sucursales.component.css'],
})
export class CardMonitoreoDetalleSucursalesComponent implements OnInit, OnDestroy {

  @BlockUI() blockUI: NgBlockUI;
  blockTemplate = BlockTemplateComponent;

  @ViewChild('modalOtrosProductos', { static: false }) modalOtrosProductos: TemplateRef<any>;
  @ViewChild('modalBalanceOtrosProductos', { static: false }) modalBalanceOtrosProductos: TemplateRef<any>;

  @Input() totalesCardDetalleSucursales!: TotalProductosCardDetalleSucursalesDto;
  @Input() informacionCapturada!: InformacionFiltroDetalleSucursalesDto;

  public  modalOtrosProductosData?: ModalOtrosProductosDto[] = [];

  public fecha: string;
  public fechaActual: boolean;

  public numero = 40;
  public resultado = 0;

  private subs = new SubSink();

  public resize$?: Observable<number>;
  public resize: number;
  public currentPage: number;
  public pageSize: number;
  public timeoutBalance: any;
  public visualizarResumen: boolean;

  constructor(
    private readonly subjectService: SubjectsService,
    public dialog: MatDialog,
    private detaSucursales: DetalleSucursalesService,
    private sweetAlertService: SweetAlertService) {
    this.resize$ = this.subjectService.resolucionPantalla;
    this.currentPage = 0;
    this.pageSize = 5;
  }

  ngOnInit(): void {
    this.obtenerResize();
    this.validarEsFechaActual();
    this.semaforoCard();
  }

  public semaforoCard(): void {
    this.resultado = (this.totalesCardDetalleSucursales?.totalLoteria * this.numero) / 100;
  }

  public obtenerResize(): number {
    this.subs.add(this.resize$.subscribe((dataResize: number) => {
      this.resize = dataResize;
    }));
    return this.resize;
  }

  public abrirModalOtrosProductos(): void {

    if (this.fechaActual) {

      if (isNaN(this.informacionCapturada.empresa)) {
        this.informacionCapturada.empresa = constantes.MENOS_UNO;
      }
      if (isNaN(this.informacionCapturada.grupos)) {
        this.informacionCapturada.grupos = constantes.MENOS_UNO;
      }
      if (isNaN(this.informacionCapturada.puntoDeVenta)) {
        this.informacionCapturada.puntoDeVenta = constantes.MENOS_UNO;
      }
      if (isNaN(this.informacionCapturada.actividad)) {
        this.informacionCapturada.actividad = constantes.MENOS_UNO;
      }
      if (isNaN(this.informacionCapturada.vendedor)) {
        this.informacionCapturada.vendedor = constantes.MENOS_UNO;
      }
      if (isNaN(this.informacionCapturada.currenPage)) {
        this.informacionCapturada.currenPage = this.currentPage;
      }
      if (isNaN(this.informacionCapturada.limit)) {
        this.informacionCapturada.limit = this.pageSize;
      }

      this.blockUI.start();

      this.subs.add(this.detaSucursales.consultarInformacionModalOtrosProductos(this.informacionCapturada).subscribe({
        next: (respuesta: GenericDto) => {
          if (respuesta.status === 200) {

            this.subjectService.informacionModalOtrosProductosSet = respuesta.payload;

            this.timeoutBalance = setTimeout(() => {
              this.dialog.open(this.modalOtrosProductos, { panelClass: 'custom-monitoreo-dialog-container' });
              this.blockUI.stop();
            }, 800);

          } else if (respuesta.status === 500) {
            this.blockUI.stop();
            this.sweetAlertService.sweetAlertError500(respuesta.payload.message);
          }
        }, error: (err) => {
          if (err.status === 503) {
            this.blockUI.stop();
            this.sweetAlertService.sweetAlertError503();
          }
        }, complete: () => { }
      }));
    }
  }

  public abrirModalBalanceOtrosProductos(): void {

    if (this.fechaActual) {

      if (isNaN(this.informacionCapturada.empresa)) {
        this.informacionCapturada.empresa = constantes.MENOS_UNO;
      }
      if (isNaN(this.informacionCapturada.grupos)) {
        this.informacionCapturada.grupos = constantes.MENOS_UNO;
      }
      if (isNaN(this.informacionCapturada.puntoDeVenta)) {
        this.informacionCapturada.puntoDeVenta = constantes.MENOS_UNO;
      }
      if (isNaN(this.informacionCapturada.actividad)) {
        this.informacionCapturada.actividad = constantes.MENOS_UNO;
      }
      if (isNaN(this.informacionCapturada.vendedor)) {
        this.informacionCapturada.vendedor = constantes.MENOS_UNO;
      }
      if (isNaN(this.informacionCapturada.currenPage)) {
        this.informacionCapturada.currenPage = this.currentPage;
      }
      if (isNaN(this.informacionCapturada.limit)) {
        this.informacionCapturada.limit = this.pageSize;
      }

      this.blockUI.start();

      this.subs.add(this.detaSucursales.consultarInformacionModalBalanceOtrosProductos(this.informacionCapturada).subscribe({
        next: (respuesta: GenericDto) => {
          if (respuesta.status === 200) {

            this.subjectService.informacionModalBalanceOtrosProductosSet = respuesta.payload;

            if (respuesta.payload.gedomFacturas === null &&
              respuesta.payload.gedomRecargas === null &&
              respuesta.payload.proveedorFacturas === null &&
              respuesta.payload.proveedorRecargas === null &&
              respuesta.payload.totalEmpresasFacturas === null &&
              respuesta.payload.totalEmpresasFacturas === null) {
              this.visualizarResumen = false;
            } else {
              this.visualizarResumen = true;
            }

            this.timeoutBalance = setTimeout(() => {
              this.dialog.open(this.modalBalanceOtrosProductos, { panelClass: 'custom-monitoreo-dialog-container' });
              this.blockUI.stop();
            }, 800);

          } else if (respuesta.status === 500) {
            this.blockUI.stop();
            this.sweetAlertService.sweetAlertError500(respuesta.payload.message);
          }
        }, error: (err) => {
          if (err.status === 503) {
            this.blockUI.stop();
            this.sweetAlertService.sweetAlertError503();
          }
        }, complete: () => { }
      }));


    }
  }

  public validarEsFechaActual(): void {
    this.subjectService.esFechaActualGet.subscribe((esFechaActual: boolean) => {
      this.fechaActual = esFechaActual;
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    clearTimeout(this.timeoutBalance);
  }
}
